import React, { useState, useEffect } from 'react';
import { LEVELS, getTotalLevels } from '../content/levels';
import PLAYER from '../playerData';
import { ASSETS } from '../assetManifest';

function Levels({ app }) {
  const totalLevels = getTotalLevels();
  const completedLevels = PLAYER.completedLevels;
  
  const handlePlayLevel = (levelNumber) => {
    app.goToGame(levelNumber);
  };
  
  return (
    <div className="Levels w-[390px] h-[690px] flex-col justify-center items-center inline-flex overflow-hidden">
      <div className="LevelDetails w-[390px] h-[844px] relative">
        <img 
          className="LevelsBg1 w-[390px] h-[844px] left-0 top-0 absolute" 
          src={ASSETS.backgrounds.levelsBackground.path} 
          alt="Levels Background"
        />
        
        <div className="LevelsTitleText w-[193px] h-[46px] left-[98px] top-[107px] absolute text-center text-[#efbb57] text-xl font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
          LEVELS
        </div>
        
        {/* Unlocked level (first level or any completed level) */}
        {Object.keys(LEVELS).map((levelKey) => {
          const levelNumber = parseInt(levelKey);
          const level = LEVELS[levelKey];
          const isUnlocked = levelNumber === 1 || completedLevels.includes(levelNumber - 1);
          const isCompleted = completedLevels.includes(levelNumber);
          
          // Calculate vertical position based on level number
          const topPosition = 153 + (levelNumber - 1) * 89;
          
          if (isUnlocked) {
            return (
              <div 
                key={levelKey} 
                className="UnlockedLevelDetails w-[353px] h-[77px] left-[18px] absolute"
                style={{ top: `${topPosition}px` }}
              >
                <div className="UnlockedLevelBackground w-[353px] h-[77px] left-0 top-0 absolute bg-[#141034]/70 rounded shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] border border-black" />
                
                <div 
                  className="PlayButton w-[66px] h-[28.29px] left-[268px] top-[24px] absolute cursor-pointer"
                  onClick={() => handlePlayLevel(levelNumber)}
                >
                  <img 
                    className="PlayBtn w-[66px] h-[28.29px] left-0 top-0 absolute" 
                    src={ASSETS.ui.playButton.path} 
                    alt="Play Button"
                  />
                  <div className="Play w-[48.81px] h-[12.76px] left-[8.87px] top-[7.76px] absolute text-center text-white text-sm font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
                    {isCompleted ? "REPLAY" : "PLAY"}
                  </div>
                </div>
                
                <div className="LevelObjectiveDetails w-[231px] h-[34px] left-[28px] top-[36px] absolute text-white text-[10px] font-bold font-Asap uppercase">
                  {level.objective.description}
                </div>
                
                <div className="LevelName w-[93px] h-[23px] left-[28px] top-[10px] absolute text-[#45fa7b] text-base font-bold font-Asap uppercase">
                  LEVEL {levelNumber}
                </div>
              </div>
            );
          } else {
            // Locked level
            return (
              <div 
                key={levelKey} 
                className="LockedLevelDetails w-[353px] h-[77px] left-[19px] absolute"
                style={{ top: `${topPosition}px` }}
              >
                <div className="LockedLevelBg w-[353px] h-[77px] left-0 top-0 absolute bg-[#1f1f1f]/70 rounded shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] border border-black" />
                
                <div className="LockedButton w-[66px] h-[28.29px] left-[267px] top-[23px] absolute">
                  <img 
                    className="LockedBtn w-[66px] h-[28.29px] left-0 top-0 absolute" 
                    src={ASSETS.ui.lockedButton.path} 
                    alt="Locked Button"
                  />
                  <div className="Locked w-[59.90px] h-[12.76px] left-[3.33px] top-[7.76px] absolute text-center text-white text-sm font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
                    locked
                  </div>
                </div>
                
                <div className="LockedLevelDescription w-[231px] h-[34px] left-[27px] top-[34px] absolute text-white text-[10px] font-bold font-Asap uppercase">
                  ???
                </div>
                
                <div className="LockedLevelName w-[93px] h-[23px] left-[27px] top-[8px] absolute text-[#82ac8f] text-base font-bold font-Asap uppercase">
                  LEVEL {levelNumber}
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}

export default Levels;
